import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
/** Maps a camelCase (wire) or snake_case change log row to the page's snake_case shape. */
export const normalizeSalesRepChange = (row) => ({
    id: row.id,
    action: row.action,
    previous_rep_label: row.previousRepLabel ?? row.previous_rep_label ?? '',
    new_rep_label: row.newRepLabel ?? row.new_rep_label ?? '',
    changed_by_label: row.changedByLabel ?? row.changed_by_label ?? '',
    source: row.source ?? '',
    source_display: row.sourceDisplay ?? row.source_display ?? '',
    created_at: row.createdAt ?? row.created_at ?? '',
});
const BASELINE_SOURCE = 'backfill';
const NOT_AVAILABLE = '—';
const ACTION_BADGES = {
    assigned: { label: 'Assigned', background: '#EBFEF6', text: '#00654F' },
    changed: { label: 'Changed', background: '#E8F1FF', text: '#1F4E9C' },
    unassigned: { label: 'Unassigned', background: '#FFF0F3', text: '#AC0824' },
    baseline: { label: 'Baseline', background: '#F2F2F2', text: '#555555' },
};
const formatDateTime = (value) => {
    const date = new Date(value);
    if (!value || Number.isNaN(date.getTime()))
        return NOT_AVAILABLE;
    return date.toLocaleString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
    });
};
export const createSalesRepHistoryColumns = () => [
    {
        key: 'created_at',
        header: 'Date',
        render: (change) => formatDateTime(change.created_at),
    },
    {
        key: 'action',
        header: 'Change',
        render: (change) => {
            // Baseline rows mark an assignment that already existed when tracking began; their date is
            // the rollout time, not when the rep was actually assigned.
            const badge = ACTION_BADGES[change.source === BASELINE_SOURCE ? 'baseline' : change.action];
            return _jsx(StatusBadge, { label: badge.label, bgColor: badge.background, color: badge.text });
        },
    },
    {
        key: 'previous_rep_label',
        header: 'From',
        render: (change) => change.previous_rep_label || NOT_AVAILABLE,
    },
    {
        key: 'new_rep_label',
        header: 'To',
        render: (change) => change.new_rep_label || NOT_AVAILABLE,
    },
    {
        key: 'changed_by_label',
        header: 'Changed By',
        render: (change) => change.changed_by_label || NOT_AVAILABLE,
    },
    {
        key: 'source_display',
        header: 'Via',
        render: (change) => change.source_display || NOT_AVAILABLE,
    },
];
